import React from 'react'
import {Icon} from '@chakra-ui/react'
const LogoutIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.25076 21.5H27.6396V18.5H6.25076V21.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.37142 20L13.4219 14.9496L11.3006 12.8282L4.12878 20L11.3006 27.1718L13.4219 25.0505L8.37142 20Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.542 1.69444H7.04199V9.30555H10.042V4.69444H34.542V35.3056H10.042V30.6944H7.04199V38.3056H37.542V1.69444Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default LogoutIcon
